import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-159">
      <div className="max-w-4xl mx-auto" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-[#FDFAF6] rounded-3xl p-10 md:p-16 text-center shadow-sm border border-[#F0FDF4] overflow-hidden" data-id="element-161">
          <Quote className="absolute top-6 left-6 w-24 h-24 text-[#2D8C4E] opacity-5 rotate-180" data-id="element-162" />
          <Quote className="absolute bottom-6 right-6 w-24 h-24 text-[#2D8C4E] opacity-5" data-id="element-163" />

          <div className="relative z-10" data-id="element-164">
            <div className="flex justify-center space-x-1 mb-8" data-id="element-165">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-[#F59E0B] text-[#F59E0B]" data-id="element-166" />)}
            </div>

            <blockquote className="text-2xl md:text-3xl font-serif text-[#1A1A1A] leading-relaxed mb-8" data-id="element-167">
              "Al día 4 ya no necesitaba el café de la tarde. La secuencia de 5
              minutos parece pequeña, pero los resultados hablan solos."
            </blockquote>

            <div className="inline-flex items-center justify-center" data-id="element-168">
              <div className="w-12 h-12 rounded-full bg-[#2D8C4E]/20 flex items-center justify-center text-[#2D8C4E] font-bold text-xl mr-4" data-id="element-169">
                M
              </div>
              <div className="text-left" data-id="element-170">
                <p className="font-bold text-[#1A1A1A]" data-id="element-171">María G.</p>
                <p className="text-gray-500 font-sans text-sm" data-id="element-172">
                  47 años, Ciudad de México
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}